import { render, staticRenderFns } from "./DispendiosProjetos.vue?vue&type=template&id=56a066ee&scoped=true&"
import script from "./DispendiosProjetos.vue?vue&type=script&lang=js&"
export * from "./DispendiosProjetos.vue?vue&type=script&lang=js&"
import style0 from "./DispendiosProjetos.vue?vue&type=style&index=0&id=56a066ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a066ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
